import NotificationBar from 'notifBar';
import Accounting from 'accounting';
import Emails from 'emails';
import MachineKeys from 'machineKeys';
import Permissions from 'permissions';
import QuestionsEditor from 'questionsEditor';
import DevTest from 'src/modules/DevTest';
import TranslationsEditor from 'src/modules/TranslationsEditor';
import CookiesBar from 'src/modules/CookiesBar';
import ImportMapping from 'src/modules/ImportMapping';
import FileLookups from 'src/modules/FileLookups';
import EmailTemplates from 'src/modules/EmailTemplates';
import Users from 'users';
import ToastContainer from 'src/modules/ToastContainer';
import Tracking from 'src/modules/Tracking';
import Chat from 'src/modules/Chat';
import { modules } from 'src/constants';

export const reactModules = [
  { module: Accounting, ref: modules.ACCOUNTING },
  {
    module: NotificationBar,
    ref: modules.NOTIF_BANNER,
    isPreLogin: true,
  },
  {
    module: ToastContainer,
    ref: modules.TOAST_CONTAINER,
    isPreLogin: true,
  },
  {
    module: Tracking,
    ref: modules.TRACKING,
    isPreLogin: true,
  },
  { module: Emails, ref: modules.EMAILS },
  { module: Permissions, ref: modules.PERMISSIONS },
  { module: MachineKeys, ref: modules.MACHINE_KEYS },
  { module: QuestionsEditor, ref: modules.QUESTIONS_EDITOR },
  { module: DevTest, ref: modules.DEV_TEST },
  { module: TranslationsEditor, ref: modules.TRANSLATIONS_EDITOR },
  { module: CookiesBar, ref: modules.COOKIES_BAR },
  { module: ImportMapping, ref: modules.IMPORT_MAPPING },
  { module: FileLookups, ref: modules.FILE_LOOKUPS },
  { module: EmailTemplates, ref: modules.EMAIL_TEMPLATES },
  { module: Users, ref: modules.USERS },
  { module: Chat, ref: modules.CHAT },
];

/**
 * Each module that requires permissions.
 * Empty array if disabled.
 * Omit if requres no permissions.
 */
export const permissionsRequiredForModules = {
  // [modules.ACCOUNTING]: [{ path: 'AccountingApi', opType: 'C' }], //Used to be just this line for accounting. Change made in RTC-52
  [modules.ACCOUNTING]: [
    { path: 'AccountingApi/AccountingAgent', opType: 'CR' },
    { path: 'AccountingApi/AgentPayment', opType: 'CRU' },
    { path: 'AccountingApi/PaymentChangeLog', opType: 'R' },
    { path: 'AccountingApi/Tolerance', opType: 'R' },
  ],
  [modules.EMAILS]: [{ path: 'EmailsApi', opType: 'R' }],
  [modules.MACHINE_KEYS]: [{ path: 'AuthApi/MachineKeys', opType: 'C' }],
  [modules.PERMISSIONS]: [{ path: 'AuthApi/Permissions', opType: 'U' }],
};
